<template>
  <div v-if="dataCertificate == null">
    <form class="login-form" @submit.prevent="certificateAuth">
      <div class="card mb-0">
        <div class="card-body">
          <div class="text-center mb-3">
            <img src="@/assets/img/logo_mini.png" class="h-72px" alt="Logo" />
            <h5 class="mt-1 mb-0">Validar Certificado</h5>
            <span class="text-muted">Entre com a chave do certificado</span>
          </div>
          <div class="mb-3">
            <div class="form-control-feedback form-control-feedback-start">
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.key.$errors.length }"
                minlength="32"
                maxlength="32"
                placeholder="Chave do Certificado"
                v-model="v$.key.$model"
              />
              <div class="form-control-feedback-icon">
                <i class="ph-key text-muted" />
              </div>
              <span v-if="v$.key.required.$invalid" class="invalid-feedback">
                O campo é obrigatório
              </span>
              <span v-if="v$.key.minLength.$invalid" class="invalid-feedback">
                A chave possui
                {{ v$.key.minLength.$params.min }} caracteres
              </span>
            </div>
          </div>
          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-primary w-100"
              title="Validar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Validar</span>
            </button>
          </div>
          <hr class="my-2" />
          <div class="text-center" title="Página Inicial">
            <router-link to="/">Página Inicial</router-link>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else class="card w-100 card-certificate">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">
        <router-link to="/" title="Página Inicial">
          Página Inicial
        </router-link>
      </h6>
      <div class="ms-auto">
        <button
          class="btn btn-light mr-2"
          title="Validar Outro Certificado"
          @click="dataCertificate = null"
        >
          Nova Validação
        </button>
        <button
          class="btn btn-success ms-2"
          title="Baixar Certificado"
          @click="download()"
        >
          Baixar
        </button>
      </div>
    </div>
    <div class="card-body p-1">
      <iframe
        v-if="certificate"
        :src="`${certificate}#&toolbar=0`"
        class="vh-80 w-100"
        frameborder="0"
        scrolling="no"
      />
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import createCertificate from '@/utils/certificate'

export default {
  name: 'CertificateAuth',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      key: '',
      dataCertificate: null,
      certificate: null,
      disableButton: false,
    }
  },

  methods: {
    async certificateAuth() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          this.dataCertificate = await this.$store.dispatch(
            'getCertificateAuth',
            this.key,
          )

          this.certificate = createCertificate({
            certificate: this.dataCertificate,
            type: 'view',
          })

          this.key = ''
          this.v$.$reset()
          this.disableButton = false
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    download() {
      createCertificate({
        certificate: this.dataCertificate,
        type: 'download',
      })
    },
  },

  validations() {
    return {
      key: {
        required,
        minLength: minLength(32),
        maxLength: maxLength(32),
      },
    }
  },
}
</script>

<style scoped>
input {
  font-size: 0.72rem;
}

.card-certificate {
  min-height: calc(100vh - 40px);
  margin-bottom: 0px;
}

.vh-80 {
  height: 80vh !important;
}
</style>
